var _defs, _rect, _use, _use2, _use3, _use4, _use5, _use6, _use7, _rect2, _use8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUsa = function SvgUsa(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1235,
    height: 650,
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "pt",
    points: "-0.1624598481164531,0 0,-0.5 0.1624598481164531,0",
    transform: "scale(0.0616)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(-144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(144)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: -0.252
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: -0.126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 0.126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 0.252
  })), /*#__PURE__*/React.createElement("g", {
    id: "s6"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5",
    x: -0.063
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 0.315
  })), /*#__PURE__*/React.createElement("g", {
    id: "x4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s6"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5",
    y: 0.054
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s6",
    y: 0.108
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5",
    y: 0.162
  })), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x4",
    y: -0.216
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x4"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s6",
    y: 0.216
  })), /*#__PURE__*/React.createElement("rect", {
    id: "stripe",
    width: 1235,
    height: 50,
    fill: "#B22234"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1235,
    height: 650,
    fill: "#FFF"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 100
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 200
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 300
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 400
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 500
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 600
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 350,
    fill: "#3C3B6E"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    transform: "translate(247,175) scale(650)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUsa);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTIzNSIgaGVpZ2h0PSI2NTAiPgo8ZGVmcz4KPHBvbHlnb24gaWQ9InB0IiBwb2ludHM9Ii0wLjE2MjQ1OTg0ODExNjQ1MzEsMCAwLC0wLjUgMC4xNjI0NTk4NDgxMTY0NTMxLDAiIHRyYW5zZm9ybT0ic2NhbGUoMC4wNjE2KSIgZmlsbD0iI0ZGRiIvPgo8ZyBpZD0ic3RhciI+PHVzZSB4bGluazpocmVmPSIjcHQiIHRyYW5zZm9ybT0icm90YXRlKC0xNDQpIi8+PHVzZSB4bGluazpocmVmPSIjcHQiIHRyYW5zZm9ybT0icm90YXRlKC03MikiLz48dXNlIHhsaW5rOmhyZWY9IiNwdCIvPjx1c2UgeGxpbms6aHJlZj0iI3B0IiB0cmFuc2Zvcm09InJvdGF0ZSg3MikiLz48dXNlIHhsaW5rOmhyZWY9IiNwdCIgdHJhbnNmb3JtPSJyb3RhdGUoMTQ0KSIvPjwvZz4KPGcgaWQ9InM1Ij48dXNlIHhsaW5rOmhyZWY9IiNzdGFyIiB4PSItMC4yNTIiLz48dXNlIHhsaW5rOmhyZWY9IiNzdGFyIiB4PSItMC4xMjYiLz48dXNlIHhsaW5rOmhyZWY9IiNzdGFyIi8+PHVzZSB4bGluazpocmVmPSIjc3RhciIgeD0iMC4xMjYiLz48dXNlIHhsaW5rOmhyZWY9IiNzdGFyIiB4PSIwLjI1MiIvPjwvZz4KPGcgaWQ9InM2Ij48dXNlIHhsaW5rOmhyZWY9IiNzNSIgeD0iLTAuMDYzIi8+PHVzZSB4bGluazpocmVmPSIjc3RhciIgeD0iMC4zMTUiLz48L2c+CjxnIGlkPSJ4NCI+PHVzZSB4bGluazpocmVmPSIjczYiLz48dXNlIHhsaW5rOmhyZWY9IiNzNSIgeT0iMC4wNTQiLz48dXNlIHhsaW5rOmhyZWY9IiNzNiIgeT0iMC4xMDgiLz48dXNlIHhsaW5rOmhyZWY9IiNzNSIgeT0iMC4xNjIiLz48L2c+CjxnIGlkPSJ1Ij48dXNlIHhsaW5rOmhyZWY9IiN4NCIgeT0iLTAuMjE2Ii8+PHVzZSB4bGluazpocmVmPSIjeDQiLz48dXNlIHhsaW5rOmhyZWY9IiNzNiIgeT0iMC4yMTYiLz48L2c+CjxyZWN0IGlkPSJzdHJpcGUiIHdpZHRoPSIxMjM1IiBoZWlnaHQ9IjUwIiBmaWxsPSIjQjIyMjM0Ii8+CjwvZGVmcz4KPHJlY3Qgd2lkdGg9IjEyMzUiIGhlaWdodD0iNjUwIiBmaWxsPSIjRkZGIi8+PHVzZSB4bGluazpocmVmPSIjc3RyaXBlIi8+PHVzZSB4bGluazpocmVmPSIjc3RyaXBlIiB5PSIxMDAiLz48dXNlIHhsaW5rOmhyZWY9IiNzdHJpcGUiIHk9IjIwMCIvPjx1c2UgeGxpbms6aHJlZj0iI3N0cmlwZSIgeT0iMzAwIi8+PHVzZSB4bGluazpocmVmPSIjc3RyaXBlIiB5PSI0MDAiLz48dXNlIHhsaW5rOmhyZWY9IiNzdHJpcGUiIHk9IjUwMCIvPjx1c2UgeGxpbms6aHJlZj0iI3N0cmlwZSIgeT0iNjAwIi8+PHJlY3Qgd2lkdGg9IjQ5NCIgaGVpZ2h0PSIzNTAiIGZpbGw9IiMzQzNCNkUiLz48dXNlIHhsaW5rOmhyZWY9IiN1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNDcsMTc1KSBzY2FsZSg2NTApIi8+PC9zdmc+";